import {AdyenReturnState} from './adyen-return.reducer.types';
import {MOBILE_PAY_REDIRECT} from '../constants/payment.constants';
import {START} from 'new-constants/app-state.constants';
import {CHECKOUT} from '../constants/navigation.constants';
import {CANCEL_MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE} from "../constants/popup.constants";

const initialState: AdyenReturnState = {
	adyenReturnOrderId: null
};

export const adyenReturnReducer = (previousState = initialState, action): AdyenReturnState => {
	switch (action.type) {
		case MOBILE_PAY_REDIRECT:
			return {
				...previousState,
				adyenReturnOrderId: action.currentTemporaryOrderId
			}
			break;
		case START:
			if(action.returnFromAdyen) {
				return {
					...previousState,
					adyenReturnOrderId: null
				}
			}

			return previousState;
			break;

		case CANCEL_MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE:
			return {
				...previousState,
				adyenReturnOrderId: null
			}
			break;

		case CHECKOUT:
			return {
				...previousState,
				adyenReturnOrderId: null
			}
			break;
		
		default:
			return previousState;
	}
};
